__turbopack_context__.v({
  "addOpacity": "Gallery-module__yncqxq__addOpacity",
  "container": "Gallery-module__yncqxq__container",
  "galleryTabs": "Gallery-module__yncqxq__galleryTabs",
  "gridContainer": "Gallery-module__yncqxq__gridContainer",
  "patchWorkGalleryContainer": "Gallery-module__yncqxq__patchWorkGalleryContainer",
  "videoBtnWrapper": "Gallery-module__yncqxq__videoBtnWrapper",
  "videoButton": "Gallery-module__yncqxq__videoButton",
});
